module.exports = __webpack_public_path__ + "img/template-preview.50563b5d.png";